import { Table as UITable } from "@/components/ui/table";
import { ListTableProps } from "@/types/list";
import { TableBody } from "./TableBody/TableBody";
import { TableHeader } from "./TableHeader";
import { cx } from "class-variance-authority";

export const ListTable = <TData,>(props: ListTableProps<TData>) => {
	const { table, renderCell, renderRowClassName, layout, expandedRowPanel } = props;
	const { sticky } = layout;
	const pageSize = table.getState().pagination.pageSize;
	return (
		<UITable
			className={cx(
				sticky && "sticky-table",
				layout.tableClassName,
				layout.hideHeader &&
					"[&_thead_th]:!h-0 [&_thead_th]:!py-0 [&_thead_th]:!border-0 [&_thead_th]:!leading-[0px] [&_thead_th]:overflow-hidden [&_thead_th]:!text-transparent [&_thead_th_*]:!text-transparent [&_thead_th>*]:!max-h-0 [&_thead_th>*]:!py-0 [&_thead_th>*]:!overflow-hidden",
			)}
		>
			<TableHeader layout={layout} headerGroups={table.getHeaderGroups()} />
			<TableBody
				layout={layout}
				rows={table.getRowModel().rows}
				allColumns={table.getVisibleLeafColumns()}
				renderCell={renderCell}
				renderRowClassName={renderRowClassName}
				pageSize={pageSize}
				expandedRowPanel={expandedRowPanel}
			/>
		</UITable>
	);
};
